import actionTypes from './action-types';

export default (state = {}, action) => {
    const setPreferred = () => {
        const { payload } = action;

        const preferred =
            state.available.find(
                language => language.languageCodeIso2 === payload
            ) || {};

        return {
            ...state,
            preferred: preferred
        };
    };

    const dismissTooltip = () => ({
        ...state,
        showTooltip: false
    });

    const dismissOptoutTooltip = () => ({
        ...state,
        showOptoutTooltip: false
    });

    const def = () => state;

    const reducers = {
        [actionTypes.SET_PREFERRED]: setPreferred,
        [actionTypes.DISMISS_TOOLTIP]: dismissTooltip,
        [actionTypes.DISMISS_OPTOUT_TOOLTIP]: dismissOptoutTooltip
    };

    return !action || !action.type || !reducers[action.type]
        ? def()
        : reducers[action.type]();
};
